module.exports = __webpack_public_path__ + "open-sans-v17-latin-regular.woff2";